import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CustomFormValidatorService } from "src/app/services/validators/custom-form-validator.service";
import { TipoSesionService } from "../../services/tipoSesion/tipo-sesion.service";
import {
  ERpaProcessStatus,
  FormBuilderSessionType,
  ISessionDetailsResponse,
  PartsCalendarSession,
  PartsCalendarTimeInputObj,
  addHoursToTimeToTimeStruct,
  initSessionValues,
} from "../../interfaces/tipo-sesion";
import { CatalogService } from "src/app/catalog/services/catalog.service";
import {
  NgbDateStruct,
  NgbTimeStruct,
  NgbTimepickerConfig,
  NgbDate,
} from "@ng-bootstrap/ng-bootstrap";
import { calendarUtils } from "../../utils/convertDates.utils";
import {
  IArea,
  ICalendarCatalog,
  IEventPlanName,
  EventPlansFilters,
} from "src/app/catalog/interfaces/catalog.interface";
import { ModalSharedServiceService } from "src/app/shared/modals/modal-service.service";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { CalendarService } from "../../services/tipoSesion/calendar.service";
import { ReqManagementService } from "src/app/requests-management/services/req-management-service.service";
import { RequestStatusOptions } from "src/app/requests-management/interfaces/requests.interface";
import { EventDetailsComponent } from "../event-details/event-details.component";
import {
  getColorByProcessStatus,
  ProcessIdByName,
} from "../../constants/ProcessId";
import { HttpErrorResponse } from "@angular/common/http";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { forkJoin, Observable, switchMap } from "rxjs";
import { getMonthName } from "src/app/shared/utils/getFixedMonthName";
import { IUser, IPonentes } from "src/app/models/Identity/user";
import { UsersService } from "src/app/manage-users/services/user-services/users.service";
import { finalize, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { monthsConstant } from "../../../course-planning/constants/constants";

@Component({
  selector: "app-modal-add-sessionv2",
  templateUrl: "./modal-add-sessionv2.component.html",
  styleUrls: ["./modal-add-sessionv2.component.css"],
})
export class ModalAddSessionv2Component implements OnInit, OnDestroy {
  public isSubmitting = false;
  public isLoadingComponent = true;
  public isLoading = false;
  public isLoadUser = false;
  public isLoadingUsers: boolean = false;
  public showUsers = true;
  public isCollapsed = true;
  public userList: IUser[] = [];
  public userInstructores: IPonentes[] = [];
  public isEventRepeat = false;
  public endDate: NgbDate | null = null;
  // filtros para eventos
  public years: number[] = [];
  public customYear: number | null = null;
  public filterYear: number | null = new Date().getFullYear();
  public filterMonth: number | null = null;
  public months = monthsConstant;

  //Subscriptions
  private unsubscribe$ = new Subject<void>();
  // inputs
  @Input()
  currentEventSelected: ISessionDetailsResponse | null = null;

  @Input()
  selectedClickDate: Date | null = null;

  // emitters
  @Output()
  closeModalEmitter = new EventEmitter<boolean>();

  @ViewChild("eventDetailsComponent")
  eventDetailsComponent!: EventDetailsComponent;

  locationControl = new FormControl();
  locations: any[] = [];

  public selectedEventId: string | null = null;
  public partBuilder: {
    date: NgbDateStruct;
    startDate: NgbTimeStruct;
    endDate: NgbTimeStruct;
    idSesionCalendarioParte: number;
    isValid: boolean;
  } = initSessionValues;
  public sessionForm!: FormGroup;
  public tiposSesion: ICalendarCatalog[] = [];
  public eventPlans: IEventPlanName[] = [];
  public areaList: IArea[] = [];

  private deletePartObsArray: Observable<Object>[] = [];
  readonly fgWeekDays = this._fb.group({
    lunes1: false,
    martes2: false,
    miercoles3: false,
    jueves4: false,
    viernes5: false,
    sabado6: false,
    domingo0: false,
  });
  //public currentUser: IUser | null = null;
  public ponenteUser: IUser | null = null;
  public userLogged: IUser | null = null;
  constructor(
    private _fb: FormBuilder,
    private _authService: AuthenticationService,
    private customFormValidator: CustomFormValidatorService,
    private tipoSesionService: TipoSesionService,
    private catalogsService: CatalogService,
    private calendarService: CalendarService,
    private modalService: ModalSharedServiceService,
    private configNgbTimeP: NgbTimepickerConfig,
    private deletionReqManagementService: ReqManagementService,
    private _userService: UsersService
  ) {
    configNgbTimeP.spinners = false;
  }

  @HostListener("window:keydown", ["$event"])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Escape" || event.code === "Escape") {
      this.cancel();
    }
  }
  // Filtros | carga dinamica del select
  loadEventPlans() {
    this.isLoading = true;

    const userId = this._authService.currentUserValue.id;
    const filters: EventPlansFilters = {
      monthNumber: this.filterMonth ?? undefined,
      yearNumber: this.filterYear ?? undefined,
    };
    this.catalogsService.getEventPlansIdByUserId(userId, filters).subscribe({
      next: r => {
        this.eventPlans = r ?? [];
        this.isLoading = false;
      },
      error: err => {
        console.log("Error", err);
        this.isLoading = false;
      },
    });
  }

  //Limpia seleccion
  onFiltersChange() {
    this.sessionForm.get("idPlaneacionCurso")?.reset();
    this.selectedEventId = null;

    this.loadEventPlans();
  }

  ngOnInit(): void {
    this.deletePartObsArray = [];
    // USERS
    this._userService.getUsers().subscribe(users => {
      this.userList = users.filter(
        usr =>
          usr.status == 1 && usr.id !== this._authService.currentUserValue.id
      );
      if (!this.currentEventSelected) {
        this.loadEventPlans();
      }
    });

    // CATÁLOGO YEARS
    if (!this.currentEventSelected) {
      this.isLoadingComponent = true;
      this.catalogsService.selectCatalogGroup("year");
      this.catalogsService.yearCatalogList
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((l: ICalendarCatalog[]) => {
          this.years = l.map(y => Number(y.nombre)).filter(y => !isNaN(y));
        });
    }

    this.userLogged = this._authService.currentUserValue;

    this.obtenerTipoSesion();
    this.initializeForm();
    if (this.currentEventSelected) {
      this.sessionForm.patchValue({
        qrMaestro: (this.currentEventSelected as any).masterQr ?? false,
      });
    }

    this.initializePartBuilder();
    this.initializePonentes();
    this.isLoadingUsers = true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    if (this.sessionForm) {
      this.sessionForm.reset();
    }
    this.partBuilder = initSessionValues;
  }
  private initializePartBuilder() {
    if (this.selectedClickDate && this.selectedClickDate > new Date()) {
      this.setSelectedDateOnParts();
    } else {
      this.partBuilder = initSessionValues;
    }
  }

  private setSelectedDateOnParts() {
    if (!this.selectedClickDate) {
      return;
    }
    this.partBuilder = {
      date: calendarUtils.getDateToPickerDate(
        this.selectedClickDate ?? new Date()
      ),
      startDate: {
        hour: this.selectedClickDate.getHours(),
        minute: this.selectedClickDate.getMinutes(),
        second: 0,
      },
      endDate: addHoursToTimeToTimeStruct(this.selectedClickDate, 1),
      idSesionCalendarioParte: this.partBuilder.idSesionCalendarioParte,
      isValid: this.partBuilder.isValid,
    };

    this.endDate ? calendarUtils.dateStructToDate(this.endDate) : null;
  }
  public onSelectEvent(a: EventTarget | null) {
    const dataSelect = a as HTMLSelectElement;
    if (!dataSelect) {
      this.selectedEventId = null;
      return;
    }

    this.selectedEventId = dataSelect.value;
    if (this.eventDetailsComponent) {
      // Actualiza el componente hijo con la nueva selección
      this.eventDetailsComponent.updateEventDetails(this.selectedEventId);
    }
  }

  private initializeForm(): void {
    if (this.currentEventSelected) {
      this.selectedEventId =
        this.currentEventSelected.idPlaneacionCurso.toString();
    }
    this.sessionForm = this._fb.group({
      idSesionCalendario: [this.currentEventSelected?.idSesionCalendario ?? 0],
      idPlaneacionCurso: [
        this.currentEventSelected?.idPlaneacionCurso ?? "",
        [Validators.required],
      ],
      nombreSession: [
        this.currentEventSelected?.nombreSesion ?? "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
        ],
      ],
      qrMaestro: [false],
      ponentes: [this.currentEventSelected?.ponentes ?? "", []],
      arrayPonentes: [this.currentEventSelected?.arrayPonentes ?? "", []],
      tipoSesion: [
        // Configuración de respuestas harcodeadas para facilitar el manejo de ID.
        // En la petición de detalles, se utiliza 'idTipoSesion', mientras que en el catálogo se utiliza 'id'.
        this.currentEventSelected?.tipoSesion.idTipoSesion ?? "",
        [Validators.required],
      ],
      location: [
        {
          externalId: this.currentEventSelected?.idLocacion ?? null,
          name: this.currentEventSelected?.ubicacion,
        },
        [Validators.required],
      ],
      objectIdSesion: [this.currentEventSelected?.objectIdSesion ?? null],
      nivel: [this.currentEventSelected?.nivel],
      partes: this._fb.array(
        this.currentEventSelected?.partsCalendarSessions.map(part =>
          this._fb.group({
            idSesionCalendarioParte: [part.idSesionCalendarioParte],
            fkIdSesionCalendario: [part.fkIdSesionCalendario],
            fecha: [part.fecha],
            fechaInicio: [part.fechaInicio],
            fechaFin: [part.fechaFin],
          })
        ) || [],
        [this.customFormValidator.atLeastOneElementOnArray]
      ),
    });
    this.initCurrentParts();
  }
  obtenerTipoSesion(): void {
    this.tipoSesionService.getTipoSesion().subscribe({
      next: t => (this.tiposSesion = t),
      error: err => console.error("Error al obtener los tipos de sesion:", err),
    });
  }

  get arrayParts() {
    return this.sessionForm.get("partes") as FormArray;
  }

  get sessionHasAttendance() {
    return (
      this.currentEventSelected?.asistenciaGbuIntegrada ||
      this.currentEventSelected?.asistenciaIntegradaSifca
    );
  }

  get eventNameMonth() {
    return this.currentEventSelected
      ? `${this.currentEventSelected.planeacion.nombre} - ${getMonthName(
          this.currentEventSelected.planeacion.fkIdMes
        )}`
      : "";
  }

  get sessionStatusIsDelete() {
    return (
      this.currentEventSelected?.fkIdProcesoSesion === ProcessIdByName.delete
    );
  }

  get rpaProcessIsSuccess() {
    return (
      this.currentEventSelected?.fkIdProcesoRpa === ERpaProcessStatus.success
    );
  }
  get rpaProcessFailed() {
    return this.currentEventSelected?.fkIdProcesoRpa === ERpaProcessStatus.fail;
  }
  get rpaProcessIsPending() {
    return (
      this.currentEventSelected?.fkIdProcesoRpa === ERpaProcessStatus.pending
    );
  }
  get statusBarColor() {
    return this.currentEventSelected
      ? getColorByProcessStatus(
          this.currentEventSelected?.fkIdProcesoSesion,
          this.currentEventSelected?.fkIdProcesoRpa,
          this.currentEventSelected.asistenciaGbuIntegrada,
          this.currentEventSelected.asistenciaIntegradaSifca
        )
      : "#fff";
  }
  get statusBarText() {
    if (!this.currentEventSelected) {
      return "";
    }
    if (this.rpaProcessIsPending) {
      return "Se esta procesando el registro en GB university, no podrás editar ni eliminar hasta que se complete el registro";
    }
    if (this.rpaProcessFailed) {
      const sessionStatus = this.currentEventSelected.fkIdProcesoSesion;
      const actionMap: Record<ProcessIdByName, string> = {
        [ProcessIdByName.create]: "registrar",
        [ProcessIdByName.update]: "actualizar",
        [ProcessIdByName.delete]: "eliminar",
      };
      const action = actionMap[sessionStatus as ProcessIdByName];
      const tryAgainMsg =
        sessionStatus === ProcessIdByName.delete
          ? "pide a tu jefe de desarrollo que vuelva a intentar la eliminación"
          : "vuelve a intentar";
      return `Hubo un error al ${action} la sesión en GB University, por favor ${tryAgainMsg}`;
    }
    if (this.currentEventSelected.asistenciaGbuIntegrada) {
      return "Asistencias enviadas.";
    }
    if (this.currentEventSelected.asistenciaIntegradaSifca) {
      return "Asistencias registradas.";
    }
    return this.getSessionStatusText(
      this.currentEventSelected.fkIdProcesoSesion
    );
  }
  get locationInput() {
    return this.sessionForm.get("location");
  }
  get locationHasIdError() {
    return (
      (this.locationInput?.touched ||
        (this.currentEventSelected &&
          !this.currentEventSelected?.idLocacion)) &&
      this.locationInput?.value &&
      !this.locationInput?.value.externalId
    );
  }

  get currentPartsHasError() {
    return this.currentParts.some(part => !part.isValid);
  }
  //Quita los filtros para modo edición
  get isEditMode(): boolean {
    return !!this.currentEventSelected;
  }

  private getSessionStatusText(sessionStatus: ProcessIdByName): string {
    switch (sessionStatus) {
      case ProcessIdByName.create:
        return "Sesión creada correctamente.";
      case ProcessIdByName.update:
        return "Sesión actualizada.";
      default:
        return "";
    }
  }
  protected isValidField(field: string): boolean | null {
    return this.customFormValidator.isInvalidField(this.sessionForm, field);
  }

  protected getFieldError(field: string) {
    return this.customFormValidator.getFieldError(this.sessionForm, field);
  }

  currentParts: PartsCalendarTimeInputObj[] = [];

  addSessionPart() {
    if (!this.partBuilder.isValid) {
      return;
    }
    this.arrayParts.setErrors(null);
    this.arrayParts.markAsTouched();

    /***************** Seleccion Periodos largos **************************************/

    if (this.isEventRepeat) {
      var startDate = new Date("2025-11-15");
      var endDate = new Date("2025-11-30");

      startDate = calendarUtils.dateStructToDate(this.partBuilder.date);
      endDate = calendarUtils.dateStructToDate(this.endDate!);
      var currentDate = startDate;

      // Create a new Date object for the loop to avoid modifying the original startDate
      for (currentDate; currentDate <= endDate; ) {
        var mydate = new Date(+currentDate);
        const fecha1 = mydate;
        var myday = mydate.getDay();

        const ngbDate: NgbDateStruct = {
          year: mydate.getFullYear(),
          month: mydate.getMonth() + 1,
          day: mydate.getDate(),
        };
        const fechaInicio1 = calendarUtils.getStructHoursToDate(
          this.partBuilder.startDate,
          ngbDate
        );
        const fechaFin1 = calendarUtils.getStructHoursToDate(
          this.partBuilder.endDate,
          ngbDate
        );

        // Validate if the day of the week is selected
        if (this.validateWeekDay(myday)) {
          this.currentParts.push({
            idSesionCalendarioParte: 0,
            fkIdSesionCalendario:
              this.currentEventSelected?.idSesionCalendario ?? undefined,
            fecha: fecha1,
            fechaInicio: fechaInicio1,
            fechaFin: fechaFin1,
            dateStruct: calendarUtils.getDateToPickerDate(fecha1),
            startDateTime: calendarUtils.getDateToPickerTime(fechaInicio1),
            endDateTime: calendarUtils.getDateToPickerTime(fechaFin1),
            isValid: true,
            isValidEnd: true,
            isValidStart: true,
          });
        }

        currentDate.setDate(currentDate.getDate() + 1);
      }
    }
    /***************** Seleccion Periodos largos **************************************/

    if (!this.isEventRepeat) {
      const fecha = calendarUtils.dateStructToDate(this.partBuilder.date);
      const fechaInicio = calendarUtils.getStructHoursToDate(
        this.partBuilder.startDate,
        this.partBuilder.date
      );
      const fechaFin = calendarUtils.getStructHoursToDate(
        this.partBuilder.endDate,
        this.partBuilder.date
      );
      this.currentParts.push({
        idSesionCalendarioParte: 0,
        fkIdSesionCalendario:
          this.currentEventSelected?.idSesionCalendario ?? undefined,
        fecha,
        fechaInicio,
        fechaFin,
        dateStruct: this.partBuilder.date,
        startDateTime: this.partBuilder.startDate,
        endDateTime: this.partBuilder.endDate,
        isValid: true,
        isValidEnd: true,
        isValidStart: true,
      });
    }

    this.arrayParts.markAsDirty();
    this.initializePartBuilder();
  }

  removeItem(i: number, parte: PartsCalendarSession) {
    if (this.rpaProcessIsPending) {
      return;
    }
    if (i >= 0 && i < this.currentParts.length) {
      this.currentParts.splice(i, 1);
      if (this.currentEventSelected && parte.idSesionCalendarioParte) {
        this.deletePartObsArray.push(
          this.calendarService.deleteCalendarSessionPart(
            parte.idSesionCalendarioParte
          )
        );
      }
      this.arrayParts.markAsDirty();
    }
    if (this.currentParts.length == 0) {
      this.arrayParts.clear();
    }
  }
  private initCurrentParts() {
    // this.verifyDates();
    if (!this.currentEventSelected) {
      return;
    }
    this.currentParts = this.currentEventSelected.partsCalendarSessions.map(
      d => ({
        ...d,
        fecha: d.fechaInicio,
        dateStruct: calendarUtils.getDateToPickerDate(d.fechaInicio),
        startDateTime: calendarUtils.getDateToPickerTime(d.fechaInicio),
        endDateTime: calendarUtils.getDateToPickerTime(d.fechaFin),
        isValid: true,
        isValidEnd: true,
        isValidStart: true,
      })
    );
  }

  verifyDates() {
    const fechaActual = new Date();
    this.arrayParts.markAsTouched();
    this.arrayParts.markAsDirty();
    const startHour = calendarUtils.getStructHoursToDate(
      this.partBuilder.startDate,
      this.partBuilder.date
    );
    const endHour = calendarUtils.getStructHoursToDate(
      this.partBuilder.endDate,
      this.partBuilder.date
    );

    if (startHour <= fechaActual) {
      this.arrayParts.setErrors({ todayForward: true });
      this.partBuilder.isValid = false;
      return;
    }
    if (endHour <= startHour) {
      this.arrayParts.setErrors({ startTimeBigger: true });
      this.partBuilder.isValid = false;
      return;
    }

    // Nueva validación para el proceso de fecha larga
    if (this.isEventRepeat) {
      var startDate = calendarUtils.dateStructToDate(this.partBuilder.date);
      var endDate = calendarUtils.dateStructToDate(this.endDate!);

      if (endDate < startDate) {
        this.arrayParts.setErrors({ endDateBeforeStartDate: true });
        this.partBuilder.isValid = false;
        return;
      }
    }

    this.arrayParts.setErrors(null);
    this.partBuilder.isValid = true;
  }

  onChangeTimeOnPartTable(part: PartsCalendarTimeInputObj) {
    this.arrayParts.markAsDirty();

    // Actualiza las fechas reales
    part.fechaInicio = calendarUtils.getStructHoursToDate(
      part.startDateTime,
      part.dateStruct
    );
    part.fechaFin = calendarUtils.getStructHoursToDate(
      part.endDateTime,
      part.dateStruct
    );

    // Validate dates
    const now = new Date();
    const startHour = part.fechaInicio;
    const endHour = part.fechaFin;

    // Reset flags
    part.isValidStart = true;
    part.isValidEnd = true;

    if (startHour <= now) {
      part.isValidStart = false;
    }

    if (endHour <= startHour) {
      part.isValidEnd = false;
    }

    part.isValid = part.isValidStart && part.isValidEnd;
  }

  async enviarFormulario() {
    this.arrayParts.clear();
    this.currentParts.forEach(parte => {
      this.arrayParts.push(
        this._fb.group({
          idSesionCalendarioParte: parte.idSesionCalendarioParte ?? 0,
          fkIdSesionCalendario: parte.fkIdSesionCalendario ?? 0,
          fecha: parte.fecha,
          fechaInicio: calendarUtils.getStructHoursToDate(
            parte.startDateTime,
            parte.dateStruct
          ),
          fechaFin: calendarUtils.getStructHoursToDate(
            parte.endDateTime,
            parte.dateStruct
          ),
        })
      );
    });
    this.sessionForm.markAllAsTouched();

    if (
      this.sessionForm.invalid ||
      this.arrayParts.length <= 0 ||
      this.currentPartsHasError
    ) {
      return;
    }
    if (this.locationHasIdError) {
      return;
    }
    if (this.sessionHasAttendance) {
      return;
    }
    if (this.sessionStatusIsDelete) {
      await this.modalService.openModal("error-modal", {
        title: "Esta sesión ya ha sido solicitada para eliminación.",
        body: "Por favor, espere a una respuesta antes de realizar cualquier otra acción.",
      });
      return;
    }
    const qrMaestro: boolean =
      this.sessionForm.get("qrMaestro")?.value ?? false;
    const isNew = !!!this.currentEventSelected;
    const confirmMessage =
      isNew ||
      this.currentEventSelected?.fkIdProcesoSesion === ProcessIdByName.create
        ? "el registro de la nueva sesión?"
        : "la actualización de la sesión?";

    const retryOrContinueMsg = this.rpaProcessFailed
      ? "reintentar"
      : "continuar con";

    const r = await this.modalService.openModal("confirm-modal", {
      title: "Confirmar",
      body: `¿Seguro que deseas ${retryOrContinueMsg} ${confirmMessage}`,
    });
    if (!r) {
      return;
    }
    const formV: FormBuilderSessionType = this.sessionForm.value;
    const newSessionBack = this.calendarService.transformToBackDto(
      formV,
      this._authService.currentUserValue.id,
      this.currentEventSelected
        ? this.currentEventSelected.fechaAlta
        : new Date(),
      qrMaestro
    );
    this.isSubmitting = true;
    let req: any;
    if (this.rpaProcessFailed) {
      newSessionBack.fkIdProcesoRpa = this.currentEventSelected?.fkIdProcesoRpa;
      newSessionBack.fkIdProcesoSesion =
        this.currentEventSelected?.fkIdProcesoSesion;
      req = this.calendarService.retrySessionProcess(newSessionBack);
    } else {
      req = this.calendarService.httpSessionPutPatch(
        newSessionBack,
        isNew,
        qrMaestro
      );
    }

    let finalReq$;
    // If there are delete session parts request, execute them first and after success execute update session request
    // if one of the delete session part request fails -> update request is not executed
    if (this.deletePartObsArray.length > 0) {
      finalReq$ = forkJoin([...this.deletePartObsArray]).pipe(
        switchMap(() => req)
      );
    } else {
      finalReq$ = req;
    }

    finalReq$.subscribe({
      next: (d: ResponseDataInterfaces<ISessionDetailsResponse>) => {
        this.isSubmitting = false;

        this.modalService
          .openModal("success-modal", {
            title: "¡Éxito!",
            body: `Solicitud realizada con éxito ${
              d.data?.idLocalizador
                ? ": Id Localizador: " + d.data.idLocalizador
                : ""
            }`,
          })
          .then(() => {
            const u = this._authService.currentUserValue;
            this.calendarService.getSessionsById(u.id.toString() ?? "");
          });

        this.cancel();
      },

      error: (error: HttpErrorResponse) => {
        this.isSubmitting = false;

        const personalizedError = error.error as ResponseDataInterfaces<null>;

        let msg = `Error al procesar la solicitud, Inténtalo mas tarde.`;

        if (
          error.status === 422 &&
          Number(personalizedError.statusCode) === 422
        ) {
          msg = personalizedError.message;
        }

        this.modalService.openModal("error-modal", {
          title: "¡Error!",
          body: msg,
        });
      },
    });
  }

  async deleteSession() {
    if (!this.currentEventSelected) {
      this.cancel();
      return;
    }
    if (!this.rpaProcessIsSuccess) {
      return;
    }
    if (this.sessionStatusIsDelete) {
      await this.modalService.openModal("error-modal", {
        title: "Esta sesión ya ha sido solicitada para eliminación.",
        body: "Por favor, espere a una respuesta antes de realizar cualquier otra acción.",
      });
      return;
    }
    const r = await this.modalService.openModal("confirm-modal", {
      title: "Confirmar",
      body: "¿Seguro que deseas eliminar la sesión? Esta acción no puede revertirse.",
    });
    if (!r) {
      return;
    }
    this.isSubmitting = true;
    const currentUser = this._authService.currentUserValue;
    const firstSession = this.currentEventSelected.partsCalendarSessions.reduce(
      (earliest, current) => {
        // Compara las fechas y devuelve el objeto con la fecha más antigua
        return new Date(current.fechaInicio) < new Date(earliest.fechaInicio)
          ? current
          : earliest;
      },
      this.currentEventSelected.partsCalendarSessions[0]
    );
    this.deletionReqManagementService
      .createDeletionRequest({
        idSesionCalendario: this.currentEventSelected.idSesionCalendario,
        nombreSesion: this.currentEventSelected.nombreSesion,
        idEstatusEliminacion: RequestStatusOptions.pending,
        idUsuarioAutoriza: currentUser.headDevelopment?.id ?? currentUser.id,
        idUsuarioSolicita: currentUser.id,
        idPlaneacionCurso: this.currentEventSelected.idPlaneacionCurso,
        fechaInicioSesion: firstSession.fechaInicio,
      })
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.isSubmitting = false;
        })
      )
      .subscribe({
        next: () => {
          this.modalService
            .openModal("success-modal", {
              title: "¡Éxito!",
              body: "Solicitud realizada con éxito",
            })
            .then(() => {
              const u = this._authService.currentUserValue;
              this.calendarService.getSessionsById(u.id.toString() ?? "");
              this.isLoading = false;
            });
          this.cancel();
        },
        error: (error: HttpErrorResponse) => {
          console.error(error);
          const personalizedError = error.error as ResponseDataInterfaces<null>;
          let msg = `Error al procesar la solicitud, Inténtalo mas tarde.`;
          if (
            error.status === 422 &&
            Number(personalizedError.statusCode) === 422
          ) {
            msg = personalizedError.message;
          }
          this.modalService
            .openModal("error-modal", {
              title: "¡Error!",
              body: msg,
            })
            .then(() => {
              this.isLoading = false;
            });
        },
      });
  }
  cancel() {
    this.deletePartObsArray = [];
    this.selectedClickDate = null;
    this.currentEventSelected = null;
    this.sessionForm.reset();
    this.closeModalEmitter.emit(true);
  }

  /******* Selesccion de periodos largos de fechas ********************/
  get btnupdown() {
    return this.sessionForm.get("bntupdown") as FormArray;
  }

  addStartTime(
    i: number,
    parte: PartsCalendarSession,
    nameFecha: string,
    action: string
  ): void {
    if (this.rpaProcessIsPending) {
      return;
    }

    const fechaActual = new Date();

    // add 10 minutes or subtract 10 minutes
    var addMinutes = 0;
    if (action == "up") {
      addMinutes = 10;
    } else if (action == "down") {
      addMinutes = -10;
    }

    // determine date to evaluate
    var nuevaFecha = new Date();

    if (nameFecha == "fechaInicio") {
      nuevaFecha = new Date(parte.fechaInicio);
    } else if (nameFecha == "fechaFin") {
      nuevaFecha = new Date(parte.fechaFin);
    }

    nuevaFecha.setMinutes(nuevaFecha.getMinutes() + addMinutes);

    // Validation
    if (nameFecha == "fechaInicio") {
      if (nuevaFecha > fechaActual) {
        if (this.currentParts[i].fechaFin > nuevaFecha) {
          this.currentParts[i].fechaInicio = nuevaFecha;
          this.arrayParts.setErrors(null);
          this.partBuilder.isValid = true;
        }
      } else {
        this.arrayParts.setErrors({ todayForward: true });
      }
    }

    // Validation
    if (nameFecha == "fechaFin") {
      if (this.currentParts[i].fechaInicio < nuevaFecha) {
        this.currentParts[i].fechaFin = nuevaFecha;
      }
    }

    this.btnupdown.markAsDirty();
  }

  totalHoras(currentPartes: PartsCalendarSession[]) {
    var sumar = 0;
    for (const parte of currentPartes) {
      sumar =
        sumar +
        (parte.fechaFin.valueOf() - parte.fechaInicio.valueOf()) /
          1000 /
          60 /
          60;
    }
    return sumar;
  }

  eventRepeat(): void {
    const today = calendarUtils.dateStructToDate(this.partBuilder.date);
    this.endDate = new NgbDate(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDate()
    );
    this.isEventRepeat = !this.isEventRepeat;
  }

  validateWeekDay(numday: number): boolean {
    var isRequired = false;

    if (numday == 0) {
      isRequired = this.fgWeekDays.controls.domingo0.value!;
    } else if (numday == 1) {
      isRequired = this.fgWeekDays.controls.lunes1.value!;
    } else if (numday == 2) {
      isRequired = this.fgWeekDays.controls.martes2.value!;
    } else if (numday == 3) {
      isRequired = this.fgWeekDays.controls.miercoles3.value!;
    } else if (numday == 4) {
      isRequired = this.fgWeekDays.controls.jueves4.value!;
    } else if (numday == 5) {
      isRequired = this.fgWeekDays.controls.viernes5.value!;
    } else if (numday == 6) {
      isRequired = this.fgWeekDays.controls.sabado6.value!;
    } else {
      isRequired = false;
    }

    return isRequired;
  }

  get getEndDateSelected() {
    return this.endDate ? calendarUtils.dateStructToDate(this.endDate) : null;
  }

  initializePonentes() {
    var addUser = this._authService.currentUserValue;
    this.userInstructores.push({
      id: addUser.id!,
      name: addUser.name,
      personNumber: addUser.personNumber,
      homeLocation: addUser.homeLocation,
    });

    var ponstr = this.currentEventSelected?.arrayPonentes ?? "";

    try {
      let arr: any = JSON.parse(ponstr);
      if (typeof arr === "string") {
        arr = JSON.parse(arr);
      }
      this.userInstructores = Array.isArray(arr) ? arr : [];
    } catch {
      console.log("No data");
    }

    var ponentesJSON = JSON.stringify(this.userInstructores);
    this.sessionForm.controls["arrayPonentes"].setValue(ponentesJSON);
  }

  removeInstructor(i: number) {
    this.userInstructores.splice(i, 1);
    var ponentesJSON = JSON.stringify(this.userInstructores);
    this.sessionForm.controls["arrayPonentes"].setValue(ponentesJSON);

    this.sessionForm.markAllAsTouched();
    this.sessionForm.markAsDirty();
  }

  addInstructor(selectedUser: IUser | null) {
    if (selectedUser == null || selectedUser === undefined) {
      return;
    }
    if (selectedUser === this.ponenteUser) {
      return;
    }
    if (!this.partBuilder.isValid) {
      return;
    }

    this.ponenteUser = selectedUser;
    this.isLoadingUsers = false;

    // Validar que no este repetido el usuario
    if (this.userInstructores.find(u => u.id === selectedUser.id)) {
      this.modalService.openModal("error-modal", {
        title: "¡Error!",
        body: "Este usuario ya fue asignado como instructor.",
      });
      this.clearPonente();
      return;
    }

    var addUser = selectedUser;
    this.userInstructores.push({
      id: addUser.id!,
      name: addUser.name,
      personNumber: addUser.personNumber,
      homeLocation: addUser.homeLocation,
    });
    var ponentesJSON = JSON.stringify(this.userInstructores);
    this.sessionForm.controls["arrayPonentes"].setValue(ponentesJSON);
    this.sessionForm.markAllAsTouched();
    this.sessionForm.markAsDirty();
    setTimeout(() => this.clearPonente(), 0);
  }

  changeEndDate() {
    const today = calendarUtils.dateStructToDate(this.partBuilder.date);
    this.endDate = new NgbDate(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDate()
    );
    this.verifyDates();
  }

  clearPonente() {
    this.ponenteUser = null;
    this.isLoadingUsers = true;
  }
}
